function generateSetID() {
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    firstPart = ("000" + firstPart.toString(36)).slice(-3);
    secondPart = ("000" + secondPart.toString(36)).slice(-3);
    return firstPart + secondPart;
}

$(document).ready(function() {

    $('.nail_care_atc').click(async function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).find('.loader-button__text').hide();
        $(this).find('.loader-button__loader').show();

        $('#MainPaymentContainer').attr('disabled', 'disabled').addClass('disabled');

        $that = this;

        let itemMain = parseInt($('.product-form__buy-buttons input[name="id"]').val());

        var product_data = [];

        let set_id = generateSetID();

        let child_variant_ids = "";

        $('.free_in_set_item.coladded').each(function() {
          if ($(this).is(':visible')) {
            child_variant_ids += parseInt($(this).attr('data-variant')) + ":" + 1;
            child_variant_ids += '__';
          }
        });

       let props = {};
        props['_bundle-parent'] = true;
        props['_set'] = set_id;
        props['_variants_set'] = child_variant_ids;
        let prod = { quantity: 1, id: itemMain, properties: props };
        product_data.push(prod);

        


      $('.free_in_set_item.coladded').each(function() {
      if ($(this).is(':visible')) {
        let upsell_prod_opt = { quantity: 1, id: parseInt($(this).attr('data-variant')) };
        upsell_prod_opt["properties"] = {
            '_bundled-product': true,
            '_discountAmount': parseFloat($(this).attr('data-discount')),
            '_set_id': set_id
        };
        product_data.push(upsell_prod_opt);
      }
    });


          console.log(product_data);

    async function addItemsToCartAndProceedNail() {
        try {
            if (window.DnAtcSource) window.DnAtcSource.stamp(product_data, null, window.DnAtcSource.templateLabel());
            const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                body: JSON.stringify({ items: product_data }),
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                },
                method: 'POST'
            });

            const responseJson = await response.json();

            if (!response.ok) {
                throw new Error(responseJson["description"] || "Error adding items to cart");
            }

            // After all items are added, proceed to the next step
            if ($('body').hasClass('direct_checkout_pd')) {
                window.location.href = '/checkout';
            } else {
                setTimeout(function() {
                    $('#MainPaymentContainer').removeAttr('disabled').removeClass('disabled');
                }, 200);
              
                fetch('/?section_id=mini-cart-new').then(res => res.text()).then(data => {
                    const html = document.createElement("div");
                    html.innerHTML = data;
                    const newbox = html.querySelector("#mini-cart").innerHTML;
                    document.querySelector('#mini-cart').innerHTML = newbox;
                })
                let cartEndPoint = window.themeVariables.routes.cartUrl || '/cart';
                fetch(`${cartEndPoint}.js`).then(async (response2) => {
                    const cartContent = await response2.json();
                    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                        bubbles: true,
                        detail: {
                            cart: cartContent
                        }
                    }));

                    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                        bubbles: true,
                        detail: {
                            cart: cartContent,
                            openMiniCart: window.themeVariables.settings.cartType === "drawer" && $that.closest(".drawer") === null
                        }
                    }));

                });
              const cartUpdateEvent = new Event('cartUpdate');
              window.dispatchEvent(cartUpdateEvent);
              
                $('.loader-button__text').show();
                $('.loader-button__loader').hide();
            }

            $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: "success",
                    error: ""
                }
            }));
        } catch (error) {
            $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: "error",
                    error: error.message
                }
            }));
        }
    }

    // Call the function to add items to the cart and proceed
    addItemsToCartAndProceedNail();
      

  });

  
});